
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar, Check, Map, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

const BottomNavigation = () => {
  const location = useLocation();
  
  const navItems = [
    {
      name: "Tableau de bord",
      path: "/",
      icon: <Calendar className="h-5 w-5" />,
    },
    {
      name: "Parcelles",
      path: "/parcels",
      icon: <Map className="h-5 w-5" />,
    },
    {
      name: "Ajouter",
      path: "/add",
      icon: <Plus className="h-5 w-5" />,
      highlight: true,
    },
    {
      name: "Observations",
      path: "/observations",
      icon: <Check className="h-5 w-5" />,
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 shadow-md">
      <div className="mobile-container">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center w-1/4 h-full transition-colors",
                location.pathname === item.path
                  ? "text-primary"
                  : "text-gray-500 hover:text-primary dark:text-gray-400 dark:hover:text-primary",
                item.highlight && "text-white"
              )}
            >
              {item.highlight ? (
                <div className="bg-primary rounded-full p-3 -mt-6">
                  {item.icon}
                </div>
              ) : (
                <div>{item.icon}</div>
              )}
              <span className="text-xs mt-1">{item.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;
